import {PagedRowsJson, PagedResponseJson} from "../json/PagedResponseJson";
import RequestBuilder from "../RequestBuilder";
import {Method} from "../enum/Method";
import RowJson from "../json/RowJson";
import CellJson from "../json/CellJson";
import {RowDataset} from "../enum/RowDataset";
import {RowOrigin} from "../enum/RowOrigin"
import {ProjectJson} from "../json/ProjectJson"
import {AnyTemplateJson} from "../json/TemplateJson"

export interface RowSearchParams {
    dataset?: RowDataset
    search?: {
        value: string
        fieldId?: string
    }
    sort: {
        by: RowSortProperty
        direction: SortDirection
    }
}

export enum RowSortProperty {
    UPDATED = "UPDATED",
}

export enum SortDirection {
    ASC = "ASC",
    DESC = "DESC"
}

export class RowRequests {
    static list(
        projectId: string,
        searchParams: RowSearchParams,
        page: number,
        size?: number,
    ): Promise<PagedRowsJson> {
        const queryParams = new URLSearchParams()
        queryParams.append("page", `${page}`)
        queryParams.append("sortBy", searchParams.sort.by)
        queryParams.append("sortDirection", searchParams.sort.direction)

        if (size !== undefined)
            queryParams.append("size", `${size}`)

        if (searchParams.dataset)
            queryParams.append("dataset", searchParams.dataset.toString())

        if (searchParams.search) {
            queryParams.append("search", searchParams.search.value)

            if (searchParams.search.fieldId) {
                queryParams.append("searchColumnId", searchParams.search.fieldId)
            }
        }

        return new RequestBuilder(Method.Get, `projects/${projectId}/rows?${queryParams.toString()}`)
            .buildAndSend()
    }

    static create(
        projectId: string,
        dataset: RowDataset,
        origin: RowOrigin,
        cells: CellJson[],
        generativeResultId: string | null,
    ): Promise<RowJson> {
        return new RequestBuilder(Method.Post, `projects/${projectId}/rows`)
            .withJson(
                {
                    dataset: dataset,
                    origin: origin,
                    cells: cells,
                    generativeResultId: generativeResultId,
                },
            )
            .buildAndSend()
    }

    static update(exampleId: number, dataset: RowDataset, cells: CellJson[]): Promise<RowJson> {
        return new RequestBuilder(Method.Put, `rows/${exampleId}`)
            .withJson(
                {
                    dataset: dataset,
                    cells: cells,
                },
            )
            .buildAndSend()
    }

    static updateAll(
        projectId: string,
        validationPercent: number,
    ): Promise<void> {
        return new RequestBuilder(Method.Put, `projects/${projectId}/rows`)
            .withJson({ validationPercent: validationPercent })
            .buildAndSend()
    }

    static get(exampleId: number): Promise<RowJson> {
        return new RequestBuilder(Method.Get, `rows/${exampleId}`)
            .buildAndSend()
    }

    static getRandom(projectId: string, number?: number, dataset?: RowDataset): Promise<PagedRowsJson> {
        const queryParams = new URLSearchParams()
        if (number) queryParams.append("number", number.toString())
        if (dataset) queryParams.append("dataset", dataset)

        return new RequestBuilder(Method.Get, `projects/${projectId}/rows/random?${queryParams.toString()}`)
            .buildAndSend()
    }

    static delete(exampleId: number): Promise<void> {
        return new RequestBuilder(Method.Delete, `rows/${exampleId}`)
            .buildAndSend()
    }
}
